export default {
  independentMarketing: {
    common: {
      requestFailed: 'インターフェース要求が失敗しました',
      hintSelect: '選択する',
      hintInput: '入力',
      submit: '提出する',
      cancel: 'キャンセル',
      confirm: 'わかりました',
    },
    agreement: {
      title: 'Autel 独立ディーラー登録契約書',
      nextBtn: '次',
      getAgreementFailed: '契約内容の取得に失敗しました。',
    },
    successPage: {
      title:
        '申請情報は正常に送信され、審査結果は 15 営業日以内にメールで $1 送信されます。詳細については、受信箱を確認してください。',
      subTitle: '$1 秒後にホームページに戻ります。',
    },
    applyTitle: 'あなたは、Autel の独立ディーラーになることを申請しています。次の情報を正確に入力してください。',
    companyName: '会社名',
    companyTax: 'VAT ID',
    userCountry: '国',
    legalPerson: '法律顧問',
    contactEmail: '連絡先メールアドレス',
    contactEmailTips:
      'このメールアドレスが審査結果メールの連絡先となります。審査が承認されると、独立系ディーラー管理システムのログインアカウント名としても使用されます。',
    corporateIdentity: '弁護士ID',
    uploadTips: 'JPG、JPEG、PNG、PDF (20 MB 以下)',
    businessLicense: '営業許可',
    emailErrorTips: '有効な電子メールを入力してください。',
    uploadPic: '画像をアップロードする',
    picMaxLimit: '最大画像サイズは 20 MB です。再度選択してください。',
  },
};
